import { useMemo } from 'react';
import {
  TimeSignalAnalyticsQuery,
  TimeSignalDimensionType,
  useTimeSignalAnalyticsQuery
} from 'graphql/types';
import { useNoteInsightsContext } from '../NoteInsightsContextProvider';
import { useGetPreviousPeriod } from './useGetPreviousPeriod';

export const useGetPreviousAnalyticsData = (
  dimension: TimeSignalDimensionType
): {
  data: TimeSignalAnalyticsQuery | undefined;
  loading: boolean;
  prevStartDate: string;
} => {
  const { currentPeriod, selectedViewOption } = useNoteInsightsContext();

  const { prevStartDate, prevEndDate } = useGetPreviousPeriod({
    currentPeriod,
    selectedViewOption
  });
  const { loading, data } = useTimeSignalAnalyticsQuery({
    variables: {
      input: {
        dimension,
        filter: {
          fromDate: prevStartDate,
          toDate: prevEndDate
        }
      }
    }
  });
  return useMemo(
    () => ({
      data,
      loading,
      prevStartDate
    }),
    [data, loading, prevStartDate]
  );
};
